import { memo } from 'react';
import { UserOutlined, TeamOutlined, EyeOutlined } from '@ant-design/icons';
import SectionTitle from '../../../../../components/sharedcomponents/SectionTitle';
import AnimatedCounter from '../../../../../components/sharedcomponents/Animations/AnimatedCounter';

interface TrendEntry {
  date: string;
  users: string;
  sessions: string;
  pageViews: string;
}

interface TrendsTabProps {
  data: TrendEntry[];
}

const TrendsTab = memo(({ data }: TrendsTabProps) => {
  const trends = data.slice(-14);

  return (
    <div>
      <SectionTitle>Tendances Quotidiennes (14 derniers jours)</SectionTitle>
      <div className="flex flex-col gap-2">
        {trends.map((t, i) => {
          const date = new Date(
            t.date.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3')
          );
          const fmt = date.toLocaleDateString('fr-FR', {
            day: '2-digit',
            month: '2-digit',
            weekday: 'short',
          });

          return (
            <div
              key={i}
              className="flex flex-wrap items-center gap-4 px-5 py-3
                         bg-white rounded-xl border border-blue-50
                         hover:bg-blue-50/30 transition-colors duration-150"
            >
              <span className="text-xs font-semibold text-blue-400 min-w-[80px]">{fmt}</span>
              <div className="flex flex-wrap gap-4 text-xs text-slate-600">
                <span className="flex items-center gap-1">
                  <UserOutlined className="text-blue-400" />
                  <AnimatedCounter
                    end={parseInt(t?.users || '0')}
                    suffix=" utilisateurs"
                    duration={800 + i * 100}
                  />
                </span>
                <span className="flex items-center gap-1">
                  <TeamOutlined className="text-blue-400" />
                  <AnimatedCounter
                    end={parseInt(t?.sessions || '0')}
                    suffix=" sessions"
                    duration={900 + i * 100}
                  />
                </span>
                <span className="flex items-center gap-1">
                  <EyeOutlined className="text-blue-400" />
                  <AnimatedCounter
                    end={parseInt(t?.pageViews || '0')}
                    suffix=" vues"
                    duration={1000 + i * 100}
                  />
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
});

TrendsTab.displayName = 'TrendsTab';

export default TrendsTab;